<template>
  <li class="result-card" @click="handleSelectProduct">
    <p class="alias">{{ product.style_id }}</p>
    <p>{{ product.name }}</p>
  </li>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import axios from "axios";
// import CONSTANTS from "@/constants.js";
// import { cloneDeep } from "lodash";
export default {
  name: "SearchResultsItem",

  props: {
    product: {
      type: Object,
    },
    activePageItem: {
      type: Object,
    },
    order: {
      type: Number,
    },
  },

  computed: {
    ...mapState(["endpoint", "dealer", "auth"]),
    ...mapState("project", ["globalUniformDecorations"]),

    ...mapGetters("project", [
      "showSnapsheetUniformProductModal",
      "snapsheetHaveUniforms",
    ]),
    ...mapGetters("snapsheet", ["getProductByOrder", "getLastSnapsheetItem"]),
  },

  methods: {
    ...mapActions("project", [
      "saveNewProduct",
      "setLastPage",
      "setTemporalProduct",
      "updateDecorationsForProjectProductsLayouts",
    ]),

    ...mapActions("catalog", ["setProjectProduct"]),
    ...mapActions("threekit", ["initProductCache"]),
    ...mapActions(["triggerStartLoading", "triggerEndLoading"]),

    async handleSelectProduct() {
      // this.triggerStartLoading(true);

      const customCatalogProductId = this.activePageItem.id;
      const customCatalogProductPageIndex =
        this.activePageItem.catalog_page_index;
      const customCatalogProductPageOrder =
        this.activePageItem.catalog_page_order;
      const newProductId = this.product.id;

      //request full product info then setActiveProduct and emit onselectedproduct
      const url = this.endpoint + `api/v2/catalog/product/swap-product`;

      this.triggerStartLoading(true);

      const params = {
        custom_catalog_product_id: customCatalogProductId,
        page_index: customCatalogProductPageIndex,
        page_order: customCatalogProductPageOrder,
        new_product_id: newProductId,
      };

      const settings = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.auth.apiToken,
        },
      };

      axios
        .post(url, params, settings)
        .then(async (response) => {
          const pr = response?.data;
  
          await this.setProjectProduct(pr);

          this.initProductCache({
            styleName: pr.style_id,
            designName: pr?.threekit_designs?.[0]?.design_name,
          });
        })
        //   const newProduct = response.data;
        //   //Get previous product to check if we can get it previous decorations
        //   const previousProduct = this.getProductByOrder(this.order);

        //   //Decorations to copy
        //   const decorations =
        //     newProduct.isUniform || newProduct.is_uniform
        //       ? //First, we check if it is an uniform product. If so, we copy the global decorations (they are set when the user adds a Uniform product for the first time)
        //         this.globalUniformDecorations
        //       : //Check if the product has layouts (no layouts means it has no decorations available)
        //       newProduct.layouts?.length > 0
        //       ? //Copy the previous product decorations, or the basic decorations structure
        //         previousProduct.decorations ||
        //         cloneDeep(CONSTANTS.PRODUCT_DECORATIONS_STRUCTURE)
        //       : {};

        //   const product = {
        //     ...newProduct,
        //     related: newProduct.related_data,
        //     decorations,
        //     wrapperId: newProduct.wrapper_id,
        //     variant:
        //       newProduct.variant ||
        //       (newProduct.variants && newProduct.variants[0].color_name),
        //     isUniform: newProduct.category === "Jerseys",
        //     isSublimable: !!newProduct.is_sublimable,
        //   };

        //   //Get Threekit data
        //   await this.initProductCache({
        //     styleName: product.style_id,
        //     designName: product?.threekit_designs?.[0]?.design_name,
        //   });

        //   //Set as temporal
        //   this.setTemporalProduct({
        //     product,
        //     order: this.order,
        //   });

        //   //Update PLP decorations
        //   await this.updateDecorationsForProjectProductsLayouts();

        //   //Set the last page as the active page, if this action was triggered from sidebar, checking if the order given is the last one
        //   if (this.getLastSnapsheetItem.order === this.order) {
        //     this.setLastPage();
        //   }

        //   //If the product is not an uniform or, if it is, there is an uniform item in the catalog, just save product directly
        //   if (!this.showSnapsheetUniformProductModal) {
        //     await this.saveNewProduct();
        //   }
        // })
        .catch((error) => {
          this.$store.dispatch("showToast", {
            txt: "An error has occurred",
            type: "error",
          });
          console.log(error);
        })
        .finally(() => {
          this.$emit("onSelectedProduct");
          this.triggerEndLoading();
        });
      // }
    },
  },
};
</script>
